"use strict";

/**
 * The selector strings live in the page's own selectors.json, which the e2e
 * suite reads too (tests/e2e/hooks.js, @bictolei) — one string, one place. The
 * file is app-owned and the suite reads it, never the reverse: requiring
 * tests/** from client code would put test-only probes in the production bundle.
 * Keys are camelCase (the suite's vocabulary); the handle names below stay
 * snake_case like the other pages' elements.js, so presentation.js is unchanged.
 */
const selectors = require("client/pages/bictoleisearch/selectors.json");

function _query (key) {
    const selector = selectors[key];
    if (!selector) {
        throw new Error("bictoleisearch/elements: no selector registered for \"" + key + "\"");
    }
    return document.querySelector(selector);
}

const elements = {
    page_wrapper: _query("pageWrapper"),
    txt_file_dialog: _query("dialog"),
    banner_container: _query("bannerContainer")
};

module.exports = elements;
